import React, { useCallback } from "react";
import styled, { css } from "styled-components";

const Pagenation = styled.div`
  display: inline-flex;
  position: relative;
  height: 28px;
  margin: 20px 0 12px;
  line-height: normal;
  font-size: 0;
  z-index: 2;
`;

const PagenationItem = styled.a`
  display: inline-block;
  position: relative;
  min-width: 26px;
  height: 26px;
  vertical-align: middle;
  line-height: 26px;
  font-size: ${props => props.theme.fontSize.default};
  white-space: nowrap;
  color: var(--font-grey);
  text-align: center;

  &:hover {
    cursor: pointer;
  }
`;

const LinkPagenation = styled(PagenationItem)<{ active?: boolean }>`
  margin: 0 4px;
  transition: color 0.2s ease-in-out;
  ${props =>
    props.active
      ? css`
          color: #1079f4;
          background-color: #f6f6f6;
          border-radius: 50%;
          font-weight: ${props => props.theme.fontWeight.bold};
          pointer-events: none;
        `
      : ""}

  &:hover {
    color: #1079f4;
  }
`;

const MovePagenation = styled(PagenationItem)`
  overflow: hidden;
  padding: 0;
  text-indent: -9999px;
  background-repeat: no-repeat;
  background-position: center;
`;

const First = styled(MovePagenation)<{ disabled?: boolean }>`
  ${props =>
    props.disabled
      ? css`
          background-image: url("/images/icon/icon_pagenation_first_disabled.svg");
          pointer-events: none;
        `
      : css`
          background-image: url("/images/icon/icon_pagenation_first.svg");
          &:hover {
            background-image: url("/images/icon/icon_pagenation_first_hover.svg");
          }
        `}
`;

const Prev = styled(MovePagenation)<{ disabled?: boolean }>`
  ${props =>
    props.disabled
      ? css`
          background-image: url("/images/icon/icon_pagenation_prev_disabled.svg");
          pointer-events: none;
        `
      : css`
          background-image: url("/images/icon/icon_pagenation_prev.svg");
          &:hover {
            background-image: url("/images/icon/icon_pagenation_prev_hover.svg");
          }
        `}
`;

const Next = styled(MovePagenation)<{ disabled?: boolean }>`
  ${props =>
    props.disabled
      ? css`
          background-image: url("/images/icon/icon_pagenation_prev_disabled.svg");
          transform: rotate(180deg);
          pointer-events: none;
        `
      : css`
          margin-left: 10px;
          background-image: url("/images/icon/icon_pagenation_prev.svg");
          transform: rotate(180deg);
          &:hover {
            background-image: url("/images/icon/icon_pagenation_prev_hover.svg");
            transform: rotate(180deg);
          }
        `}
`;

const Last = styled(MovePagenation)<{ disabled?: boolean }>`
  ${props =>
    props.disabled
      ? css`
          background-image: url("/images/icon/icon_pagenation_first_disabled.svg");
          transform: rotate(180deg);
          pointer-events: none;
        `
      : css`
          background-image: url("/images/icon/icon_pagenation_first.svg");
          transform: rotate(180deg);
          &:hover {
            background-image: url("/images/icon/icon_pagenation_first_hover.svg");
            transform: rotate(180deg);
          }
        `}
`;

export interface IProps {
  current: number;
  total: number;
  change?: (page: number) => void;
}

function Pagelable(props: IProps): JSX.Element {
  const temp = [];
  for (let i = 0; i < (props.total < 10 ? props.total : 10); i++) {
    temp.push(
      i +
        (props.total <= 10
          ? 0
          : props.current - 4 > 0
          ? props.current - 4 > props.total - 10
            ? props.total - 10
            : props.current - 4
          : 0) +
        1,
    );
  }
  const goPage = useCallback(
    (disabled: boolean, idx: number) => {
      if (disabled !== true && props.change) {
        props.change(idx - 1);
      }
    },
    [props],
  );
  return (
    <Pagenation>
      <First disabled={props.current === 0} onClick={goPage.bind(null, props.current === 0, 1)} />
      <Prev disabled={props.current === 0} onClick={goPage.bind(null, props.current === 0, props.current)} />
      {temp.map((item, idx) => (
        <LinkPagenation
          key={idx}
          active={item - 1 === props.current}
          onClick={goPage.bind(null, item - 1 === props.current, item)}
        >
          {item}
        </LinkPagenation>
      ))}
      <Next
        disabled={props.total === 0 || props.current === props.total - 1}
        onClick={goPage.bind(null, props.total === 0 || props.current === props.total - 1, props.current + 2)}
      />
      <Last
        disabled={props.total === 0 || props.current === props.total - 1}
        onClick={goPage.bind(null, props.total === 0 || props.current === props.total - 1, props.total)}
      />
    </Pagenation>
  );
}
Pagelable.defaultProps = {
  current: 0,
  total: 0,
};
export default React.memo(Pagelable);
